module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-6-svgrepo-com.8d9f7813.svg";